import React, { Dispatch, FC, SetStateAction } from 'react'
import { DeleteIconButton, TextButton } from 'components/Button'
import { Card, CardInner } from 'components/Card'
import { FlexRow } from 'components/Flex'
import { RadioButton, TextInput } from 'components/Form'
import { HorizontalLine, Spacer } from 'components/Utility'
import { ScheduleType } from 'types/schedule'
import { useChoices } from 'hooks/bread'
import { StockUnionType } from 'types/stock'

type Props = {
  choices: string[]
  setSchedules: Dispatch<SetStateAction<ScheduleType[]>>
  type: StockUnionType
}

const ChoiceFormWrapper: FC<Props> = (props) => {
  const { choices, setSchedules, type } = props

  const { addChoice, clearChoices, deleteChoice, handleChoices, initChoices } = useChoices(setSchedules)

  return (
    <>
      <Card isOutlined={true}>
        <CardInner>
          <RadioButton
            isChecked={choices.length > 0}
            label={'受渡しオプション有り'}
            onChange={initChoices}
            value={`has_option_${type}`}
          />
        </CardInner>
        <HorizontalLine color={'grey03'} verticalMargin={16} />
        <CardInner>
          {choices.map((choice, index) => (
            <React.Fragment key={index.toString()}>
              <FlexRow justifyContent={'start'}>
                <TextInput
                  disabled={false}
                  onChange={(event) => handleChoices(event, index)}
                  placeholder={'4枚切り'}
                  required={false}
                  size={'small'}
                  type={'text'}
                  value={choice}
                />
                <Spacer size={8} />
                <DeleteIconButton disabled={choices.length === 1} onClick={() => deleteChoice(index)} />
              </FlexRow>
              <Spacer size={16} />
            </React.Fragment>
          ))}
          <FlexRow justifyContent={'center'}>
            {choices.length === 0 || choices.some((choice) => choice === '') ? (
              <TextButton
                disabled={true}
                iconPath={'/icon/grey/plus.svg'}
                label={'オプションを追加する'}
                onClick={addChoice}
              />
            ) : (
              <TextButton iconPath={'/icon/blue/plus.svg'} label={'オプションを追加する'} onClick={addChoice} />
            )}
          </FlexRow>
        </CardInner>
      </Card>
      <Spacer size={8} />
      <Card isOutlined={true}>
        <CardInner>
          <RadioButton
            isChecked={choices.length === 0}
            label={'受渡しオプション無し'}
            onChange={clearChoices}
            value={`no_option_${type}`}
          />
        </CardInner>
      </Card>
    </>
  )
}

export default ChoiceFormWrapper
